<div class="input-group">
  <ng-content></ng-content>
  <ng-container *ngIf="type !== 'custom' && type !== 'number'">
    <input
      class="form-control"
      [type]="type"
      [placeholder]="initialValue"
      [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)"
      (keyup.enter)="apply.emit()"
      (keyup.escape)="cancel.emit()"
    />
  </ng-container>
  <ng-container *ngIf="type === 'number'">
    <input
      class="form-control"
      type="text"
      [placeholder]="initialValue"
      [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)"
      (keyup.enter)="apply.emit()"
      (keyup.escape)="cancel.emit()"
      (keypress)="requireNumber($event)"
    />
  </ng-container>
  <button class="btn btn-primary" type="button" [disabled]="disabled" (click)="apply.emit()">
    <fa-icon icon="check"></fa-icon>
  </button>
  <button class="btn btn-secondary" type="button" [disabled]="disabled" (click)="cancel.emit()">
    <fa-icon icon="times"></fa-icon>
  </button>
</div>
